<template>
  <Header></Header>
  <SideBar></SideBar>

  <Body pageTitle="Schedule Product">
    <template v-slot:body>
      <div class="d-flex row schedule-product-container" ref="container">
        <div class="media-views flex-1" ref="mediaViews">
          <div class="media-toolbar d-flex justify-content-between">
            <div class="dropdown">
              <button type="button" class="dropdown-toggle btn btn-outline-success" @click.stop.prevent="dropdownToggle">Choose Images</button>
              <div tabindex="-1" role="menu" class="dropdown-menu">
                <div class="d-flex flex-column">
                  <div tabindex="0" class="btn btn-upload btn-transition btn-outline-light p-2 pl-3 border-0 text-left cursor-pointer" @click="dropdownClose">
                    <label for="upload-media-file" class="p-0 m-0 w-100 cursor-pointer">Images</label>
                    <input type="file" id="upload-media-file" @change="changeMedia" multiple />
                  </div>
                  <div tabindex="0" class="btn btn-upload btn-transition btn-outline-light p-2 pl-3 border-0 text-left cursor-pointer" @click="dropdownClose">
                    <label for="upload-media-folder" class="p-0 m-0 w-100 cursor-pointer">Image Folders</label>
                    <input type="file" id="upload-media-folder" @change="changeMedia" webkitdirectory />
                  </div>
                </div>
              </div>
            </div>
            <a href="#" class="btn-transition btn btn-outline-primary float-right" @click="submit">Upload</a>
          </div>
          <div class="media-content" ref="mediaContent">
            <ThumbnailPreview class="p-2" :values="newImages" @changeValues="changeImages">
              <template v-slot:before-wrapper="imageProps">
                <input type="checkbox" :data-id="imageProps.index" @click="checkMultipleFiles" />
              </template>
            </ThumbnailPreview>
            <div class="image-uploaded"><span>Used</span></div>
            <ThumbnailPreview class="p-2" :values="oldImages" @changeValues="changeImages">
              <template v-slot:before-wrapper="imageProps">
                <input type="checkbox" :data-id="imageProps.index" @click="checkMultipleFiles" />
              </template>
            </ThumbnailPreview>
          </div>
        </div>
        <div class="list-account p-3" ref="listAccount">
          <div class="filters-form">
            <div class="form-group">
              <Select class="mt-2" source="term/search" v-model="query.term_id" @change="queryChange"></Select>
            </div>
            <div class="form-group">
              <input type="text" v-model="query.search" class="form-control" placeholder="Account name" @change="queryChange" />
            </div>
            <PageNav :display="{ total: false }" :config="query" @changeValue="changePage" class="d-flex mt-2 col-12 justify-content-center float-none pagination-wrapper"></PageNav>
          </div>
          <ul class="p-0 pt-3 list">
            <li class="account" v-for="(account, index) in accounts" :key="index" :data-id="index">
              <div class="title">{{ account.account_name }}</div>
              <div class="schedule">
                <select class="form-control" v-model="schedules[account.account_id]" :ref="`schedule-${account.account_id}`">
                  <option v-if="account.schedules.length > 1" value="">-- Select Template --</option>
                  <option v-for="schedule in account.schedules" :key="schedule.id" :value="schedule.id">
                    {{ schedule.name }}
                  </option>
                </select>
              </div>
              <a href="#" class="toggle-images" @click="toogleTemplateImages(account.account_id)">Show/Hide selected images</a>
              <div class="preview-container">
                <ThumbnailPreview v-if="showTemplateImages[account.account_id]" :values="templateImages(account.account_id)" @changeValues="unsetImageFile"></ThumbnailPreview>
              </div>
              <a href="#" class="btn-transition btn btn-outline-success" @click.prevent="addSelectedFileToTemplate(account.account_id)">Add selected images</a>
            </li>
          </ul>
        </div>
      </div>
    </template>
  </Body>
</template>

<script>
import Event from '@/helper/event.js'
import Header from '@/layouts/Header.vue'
import SideBar from '@/layouts/SideBar.vue'
import Body from '@/layouts/Body.vue'
import ThumbnailPreview from '@/components/ThumbnailPreview.vue'
import PageNav from '@/components/PageNav.vue'
import Md5 from 'crypto-js/md5'

export default {
  mixins: [Event],
  components: {
    Header,
    SideBar,
    Body,
    ThumbnailPreview,
    PageNav
  },
  data() {
    return {
      maxUploadPerAccount: 10,
      query: {
        term_id: '',
        search: '',
        total: 0,
        limit: 20,
        page: 1
      },
      images: {},
      accounts: {},
      schedules: {},
      lastClick: null,
      showTemplateImages: {}
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
    document.body.addEventListener('keydown', this.keyboardEvent)
    let interval = setInterval(() => {
      if (this.onResize()) {
        clearInterval(interval)
      }
    }, 100)
    this.$util.event.listener('addProduct.PushFileUpload', this.pushMediaEvent)
  },
  unmounted() {
    window.removeEventListener('resize', this.onResize)
    document.body.removeEventListener('keydown', this.keyboardEvent)
  },
  computed: {
    newImages() {
      return this.$util.filter(this.images, ({ item }) => {
        return item.used == false && item.template == ''
      })
    },
    oldImages() {
      return this.$util.filter(this.images, ({ item }) => {
        return item.used == true && item.template == ''
      })
    }
  },
  methods: {
    config() {
      return {
        preload: true,
        tableId: 'schedule-process',
        indexUri: 'schedule-process',
        storeId: ['main']
      }
    },
    onResize() {
      const getOffset = (elem) => {
        let win = elem.ownerDocument.defaultView
        let rect = elem.getBoundingClientRect()
        return {
          top: rect.top + win.pageYOffset,
          left: rect.left + win.pageXOffset
        }
      }
      const classes = ['mediaContent', 'listAccount']
      classes.forEach((index) => {
        if (this.$refs[index]) {
          this.$refs[index].style.height = window.innerHeight - getOffset(this.$refs[index]).top + 'px'
        }
      })

      if (window.innerHeight == document.body.offsetHeight) {
        return true
      }
      return false
    },
    keyboardEvent(e) {
      if (e.keyCode == 65 || e.keyCode == 97) {
        if (e.ctrlKey) {
          this.$refs.mediaViews.querySelectorAll('.img-preview-wrapper input[type="checkbox"]:not(:checked)').forEach((elem) => {
            elem.checked = true
          })
          e.preventDefault()
          e.stopPropagation()
          return false
        }
      }
    },
    checkMultipleFiles: function (e) {
      let $this = e.currentTarget.closest('.img-preview-wrapper')
      if (this.lastClick) {
        if (e.shiftKey) {
          let $siblings = Object.values($this.parentElement.children)
          let start = $siblings.indexOf(this.lastClick)
          let end = $siblings.indexOf($this)

          $siblings.slice(Math.min(start, end), Math.max(start, end) + 1).forEach((elem) => {
            elem.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
              checkbox.checked = true
            })
          })
        }
      }
      this.lastClick = $this
    },
    dropdownToggle(e) {
      e.currentTarget.nextElementSibling.classList.toggle('show')
    },
    dropdownClose(e) {
      e.currentTarget.parentElement.parentElement.classList.remove('show')
    },
    changeImages(values, e) {
      if (this.images[e.deleted] != undefined) {
        delete this.images[e.deleted]
      }
    },
    getFileName: function (str) {
      return str.replace(/\.[^/.]+$/, '').toLowerCase()
    },
    changePage(value) {
      this.query.page = value
      this.queryChange(false)
    },
    queryChange(reload) {
      if (_.isUndefined(reload)) {
        reload = true
      }
      if (this.query.term_id != '') {
        if (reload) {
          this.query.page = 1
        }
        this.$util.post(
          'schedule-product/suggest-account',
          this.query,
          this.$refs.listAccount,
          {
            done: (response) => {
              if (response.status == 'success') {
                this.accounts = response.data
                this.query.total = response.total
                Object.values(this.accounts).forEach((account) => {
                  if (!_.isUndefined(account.account_id) && _.isArray(account.schedules) && account.schedules.length > 0) {
                    if (account.schedules.length == 1) {
                      this.schedules[account.account_id] = account.schedules[0].id
                    } else {
                      this.schedules[account.account_id] = ''
                    }
                  }
                })
              }
            },
            error: (response) => {
              console.log(response)
            }
          },
          {
            method: 'GET'
          }
        )
      }
    },
    templateImages(account_id) {
      if (this.schedules[account_id] != '') {
        return this.$util.filter(this.images, ({ item }) => {
          return item.template == this.schedules[account_id]
        })
      }
      return []
    },
    addSelectedFileToTemplate(account_id) {
      if (this.schedules[account_id] != '') {
        let scheduleIds = []
        let uploadedProduct =
          this.accounts[account_id].schedules.reduce((total, schedule) => {
            scheduleIds.push(schedule.id)
            return schedule.today + (total || 0)
          }, 0) +
          Object.keys(
            this.$util.filter(this.images, ({ item }) => {
              return scheduleIds.indexOf(item.template) != -1
            })
          ).length

        this.$refs.mediaViews.querySelectorAll('input[type="checkbox"]:checked').forEach((checkbox) => {
          if (uploadedProduct < this.maxUploadPerAccount) {
            let template = checkbox.getAttribute('data-id')
            if (this.images[template] != undefined) {
              checkbox.checked = false
              this.images[template].template = this.schedules[account_id]
            }
            uploadedProduct++
          } else {
            this.$util.notify({
              status: 'error',
              text: `You can only upload ${this.maxUploadPerAccount} photos / account per day!`
            })
          }
        })
      }
    },
    toogleTemplateImages(account_id) {
      if (this.showTemplateImages[account_id] === true) {
        this.showTemplateImages[account_id] = undefined
      } else {
        this.showTemplateImages[account_id] = true
      }
    },
    unsetImageFile(values, e) {
      if (!_.isUndefined(this.images?.[e.deleted]?.template)) {
        this.images[e.deleted].template = ''
      }
    },
    changeMedia(e) {
      e.preventDefault()
      let $this = e.currentTarget
      let object = {}
      let title
      Object.values($this.files).forEach((file) => {
        if (file.webkitRelativePath == '') {
          title = file.name.split('.').slice()[0]
        } else {
          title = file.webkitRelativePath.split('/').slice(-2)[0]
        }
        if (_.isString(title) && String(title).length > 0) {
          if (object[this.getFileName(title)] == undefined) {
            object[this.getFileName(title)] = {
              files: []
            }
          }
          object[this.getFileName(title)].files.push(file)
        }
      })

      $this.value = ''
      this.initializeFileUpload(object)
    },
    pushMediaEvent(e) {
      let object = {}
      let title
      Object.values(e.detail).forEach((item) => {
        title = item.title
        if (_.isString(title) && String(title).length > 0) {
          if (object[this.getFileName(title)] == undefined) {
            object[this.getFileName(title)] = {
              files: []
            }
          }
          object[this.getFileName(title)].files.push(item.file)
        }
      })
      this.initializeFileUpload(object)
      this.$util.event.create('addProduct.PushFileUploadDone')
    },
    initializeFileUpload(object) {
      let titles = Object.keys(object)
      if (titles.length > 0) {
        this.$util.post('schedule-product/uploaded', { titles }, this.$refs.mediaViews, {
          done: (response) => {
            if (response.status == 'success' && _.isArray(response.titles)) {
              let hash
              for (const [title, value] of Object.entries(object)) {
                hash = Md5(title).toString()
                if (this.images[hash] == undefined) {
                  this.images[hash] = {
                    title: title,
                    template: '',
                    uploaded: 0,
                    used: response.titles.indexOf(title) != -1,
                    files: [],
                    fileids: {}
                  }
                }
                this.images[hash].files = value.files
              }
              this.uploadFiles()
            }
          },
          error: (response) => {
            console.log(response)
          }
        })
      }
    },
    uploadFiles() {
      this.$util.uploadFiles(this.images, {
        completed: (response) => {
          Object.entries(response.success).forEach(([id, object]) => {
            if (_.isObjectLike(this.images[id]) && _.isObjectLike(object.fileids)) {
              this.images[id].fileids = { ...object.fileids }
            }
          })
        }
      })
    },
    submit() {
      let data = []
      Object.values(this.images).forEach((object) => {
        if (String(object.template).length > 0) {
          if (Object.keys(object.fileids).length == object.files.length) {
            data.push({
              title: object.title,
              template: object.template,
              fileids: object.fileids
            })
          } else {
            this.$util.notify({
              status: 'error',
              text: `Please wait for the file [${object.title}] to upload or remove it from the list`
            })
          }
        }
      })

      if (data.length > 0) {
        this.$util.post('schedule-product/update', { files: data }, this.$refs.container, {
          done: (response) => {
            if (response.status == 'success') {
              setTimeout(() => {
                alert('The browser will be refresh!')
                location.reload()
              }, 1000)
            }
          },
          error: (response) => {
            console.log(response)
          }
        })
      }
    }
  }
}
</script>
<style lang="scss">
body.page-schedule-product {
  .schedule-product-container {
    border-top: 1px solid #e9ecef;
    background: #fff;
    margin: -30px;
    .img-preview-wrapper {
      width: 16.6666%;
      min-width: 67px;
      &:not(.uploaded) {
        opacity: 0.4;
      }
      input[type='checkbox'] {
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
        width: 100%;
        height: 100%;
        z-index: 9;
        &:checked ~ div .img-preview {
          border: 3px solid #00a6ff;
        }
      }
      &.uploaded {
        .progress {
          display: none;
        }
      }
    }
    .list-account {
      width: 350px;
      border-left: 1px solid #dfdfdf;
      height: calc(100vh - 175px);
      overflow-y: auto;
      position: relative;
      ul {
        border-top: 1px dashed #dfdfdf;
        list-style: none;
      }
      .account {
        border: 1px solid #dfdfdf;
        padding: 15px;
        border-radius: 3px;
        margin-bottom: 20px;
        .title {
          font-size: 16px;
          font-weight: bold;
          padding-bottom: 10px;
          margin-bottom: 15px;
          border-bottom: 1px solid #dfdfdf;
          cursor: default;
        }
        .toggle-images {
          margin: 10px 0;
          display: block;
        }
      }
    }

    .media-views {
      .media-toolbar {
        border-bottom: 1px solid #dfdfdf;
        background: #f7f9fa;
        padding: 10px;
      }
      .media-content {
        overflow-y: auto;
      }
      .image-uploaded {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 30px;
        &:before {
          position: absolute;
          top: 50%;
          left: 0;
          width: 100%;
          height: 0;
          border-top: 1px solid #a5a5a5;
          border-bottom: 1px solid #cecece;
          z-index: 0;
          content: '';
        }
        span {
          position: relative;
          background: #fff;
          padding: 5px 15px;
          color: #ff5757;
          font-style: italic;
        }
      }
    }
  }
}
</style>
